<template>
    <HistorySection />
  </template>
  
  <script>
  import HistorySection from '@/components/HistorySection.vue'
  
  export default {
    name: 'HistoryView',
    components: {
      HistorySection
    }
  }
  </script>